var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFasting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81371 1.54924L6.52195 2.87151C4.86768 3.75757 3.50524 5.12 2.61918 6.77427L1.29691 6.06604C2.32263 4.15103 3.8987 2.57496 5.81371 1.54924ZM0.470946 8.05811C0.164675 9.069 0 10.1414 0 11.2523C0 12.3632 0.164675 13.4357 0.470946 14.4465L1.90651 14.0116C1.64249 13.1402 1.5 12.2143 1.5 11.2523C1.5 10.2904 1.64249 9.36446 1.90651 8.49305L0.470946 8.05811ZM1.29691 16.4386L2.61918 15.7304C3.50524 17.3847 4.86768 18.7471 6.52195 19.6331L5.81371 20.9554C3.8987 19.9297 2.32263 18.3536 1.29691 16.4386Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.75 11.2523C20.75 5.63735 15.6702 0.583146 8.64709 1.98776L8.35291 0.516886C16.3298 -1.07848 22.25 4.71705 22.25 11.2523C22.25 17.7876 16.3298 23.5831 8.35291 21.9878L8.64709 20.5169C15.6702 21.9215 20.75 16.8673 20.75 11.2523Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 10.6028C15.375 10.8915 15.375 11.6132 14.875 11.9019L9.625 14.9329C9.125 15.2216 8.5 14.8608 8.5 14.2834V8.22125C8.5 7.6439 9.125 7.28305 9.625 7.57173L14.875 10.6028Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFasting);
export default __webpack_public_path__ + "static/media/fasting.0071fc28691083e46cf09a02d70cc177.svg";
export { ForwardRef as ReactComponent };